
import { defineComponent, ref, reactive, onMounted } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

//components
import Header from "@/components/shared/Header.vue"
import subHeader from "@/components/shared/subHeader.vue"
import KTFile from "@/components/files/File.vue";

//services
import PublicService from "@/core/services/PublicService";
import GlobalService from '@/core/services/GlobalService';
import servCertificate from "@/core/services/CertificateService"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { errManager, showNotification } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";
import { applyElementPlusPrimaryFromApi } from '@/core/config/elementTheme';

export default defineComponent({
    name: "Certificates",
    components: {
        Header, subHeader, KTFile
    },
    setup() {
        const i18n = useI18n();
        const route = useRoute();
        const loading = ref(false)
        const company = ref<any>({})
        const urlDownload = ref(process.env.VUE_APP_API_URL)
        const listCourses = ref<any>([])
        const searchFormRef = ref<FormInstance>()
        const REPO = ref(process.env.VUE_APP_REPO)
        const searchForm = reactive(<any>{
            periodo: 2026,
            category: null,
            doctype: '1',
            docnumber: null,
            company: null
        })

        const rules = reactive(<FormRules>{
            doctype: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            docnumber: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
        })

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid) onSearch();
            });
        }

        const onSearch = async () => {
            loading.value = true;
            listCourses.value = []
            servCertificate.getSearch(searchForm)
                .then((res) => {
                    loading.value = false;
                    listCourses.value = res.data.courses;
                    showNotification(res.data);
                    if (res.data.status != 'success')
                        Swal.fire({
                            icon: res.data.status,
                            title: res.data.title,
                            html: res.data.message
                        })
                }).catch(({ response }) => {
                    loading.value = false;
                    errManager(response)
                })
        }

        const setLang = (lang) => {
            localStorage.setItem("lang", lang);
            i18n.locale.value = lang;
        };

        const getCompany = async () => {
            loading.value = true
            await PublicService.getCompany(route.params.company)
                .then(async(res) => {
                    company.value = res.data
                    searchForm.company = res.data?.alias
                    await applyElementPlusPrimaryFromApi(company.value?.setting?.bg?.primary);
                    loading.value = false;
                }).catch(({ response }) => {
                    loading.value = false
                })
        }

        onMounted(() => {
            setLang("es");
            getCompany();
        });

        return {
            REPO,
            loading,
            listCourses,
            urlDownload,
            searchFormRef,
            searchForm,
            rules,
            company,

            //methods
            submitForm,
            onSearch,
            setLang,
            getCompany
        }
    },
})
